import { Injectable } from "@angular/core";
import { ProductionJobView } from "@models/ui/production-job-view.model";
import { ProductionJobSdk } from "@sdks/production-job.sdk";
import { BehaviorSubject, Observable } from "rxjs";


@Injectable({
	providedIn: 'root'
})
export class ProductionJobsStore {
	private createdJob = new BehaviorSubject<ProductionJobView>(null);
	private productionJobs = new BehaviorSubject<ProductionJobView[]>([]);
	private canceled = new BehaviorSubject<boolean>(false);

	public productionJobs$: Observable<ProductionJobView[]> = this.productionJobs.asObservable();
	public createdJob$: Observable<ProductionJobView> = this.createdJob.asObservable();
	public canceled$: Observable<boolean> = this.canceled.asObservable();

	constructor(private productionJobSdk: ProductionJobSdk) {
		this.loadAllJobs();
	}

	public updateProductionJobs(newJob: ProductionJobView): void {
		const currentListOfJobs = this.productionJobs.value;
		const updatedList = [...currentListOfJobs, newJob];
		this.productionJobs.next(updatedList);
	}

	public setCreatedJob(newJob: ProductionJobView): void {
		this.createdJob.next(newJob);
	}

	public toggleCanceled(): void {
		this.canceled.next(true);
	}

	public loadAllJobs(): void {
		this.productionJobSdk.get({ status: 0 })
			.subscribe({
				next: (data) => {
					this.productionJobs.next(data);
				}
			});
	}



}
